import { Document, Font, Page, Text, View } from "@react-pdf/renderer";
import pdfConstants from "../util/PDFConstants";
import PDFHeader from "../util/PDFHeader";
import PDFClientHeader from "../util/PDFClientHeader";


function AgreementPoliciesPDF(props) {


    return (
        <Document>
            <Page size="A4" style={pdfConstants.pdfStyles.page}>

                <PDFHeader
                    title={"DESIGN YARD CHRISTMAS LIGHTS 2025-2026 SERVICE/ AGREEMENT POLICIES, TERMS, AND CONDITIONS"}
                />

                <PDFClientHeader
                    client={props.client}
                    clientAddress={props.clientAddress}
                />
                
                <View style={pdfConstants.pdfStyles.quoteRecipient}>
                    <View style={pdfConstants.pdfStyles.row60NoBorder}>
                        <Text style={pdfConstants.pdfStyles.bigColumn100Agreement}>
                            {"Upon scheduling of work or paying any money to DESIGN YARD   Christmas lights LLC, The hiring party has agreed to this contract and it's entirely."}
                        </Text>
                    </View>
                </View>

                <View style={pdfConstants.pdfStyles.quoteRecipient}>
                    <View style={pdfConstants.pdfStyles.row60NoBorder}>
                        <Text style={pdfConstants.pdfStyles.bigColumn100Agreement}>
                            {"DESIGN YARD   Christmas Lights LLC  provides a service to design, install, removal and leave  holiday decorations at your house . This service agreement outlines the expectations and acknowledgement of the client (AKA the Hiring party)."}
                        </Text>
                    </View>
                </View>

                <View style={pdfConstants.pdfStyles.quoteRecipient}>
                    <View style={pdfConstants.pdfStyles.row60NoBorder}>
                        <Text style={pdfConstants.pdfStyles.bigColumn100Agreement}>
                            {"LIGHTING AND DECORATIONS:"}
                        </Text>
                    </View>
                </View>

                <View style={pdfConstants.pdfStyles.quoteRecipient}>
                    <View style={pdfConstants.pdfStyles.row60NoBorder}>
                        <Text style={pdfConstants.pdfStyles.bigColumn100Agreement}>
                            {"DESIGN YARD   Christmas Lights LLC  warranties the quality of our decorations and workmanship as described below. Should you have ANY problems with the decorations, we want to correct them as soon as possible. "}
                        </Text>
                    </View>
                </View>


                <View style={pdfConstants.pdfStyles.quoteRecipient}>
                    <View style={pdfConstants.pdfStyles.row60NoBorder}>
                        <Text style={pdfConstants.pdfStyles.bigColumn100Agreement}>
                            {"Please inform us of any gate codes or restrictions that may hinder DESIGN YARD    Christmas lights from correcting, fixing or repossessing decorations."}
                        </Text>
                    </View>
                </View>

                <View style={pdfConstants.pdfStyles.quoteRecipient}>
                    <View style={pdfConstants.pdfStyles.row90NoBorder}>
                        <Text style={pdfConstants.pdfStyles.bigColumn100Agreement}>
                            {"It is understood by ALL parties involved, that  DESIGN YARD    Christmas Lights makes NO sale of any products. All materials used in decoration as described in the estimate/invoice is the property of DESIGN YARD   Christmas lights LLC. It is understood that all materials are on lease and to be repossessed in January of the following year."}
                        </Text>
                    </View>
                </View>

                <View style={pdfConstants.pdfStyles.quoteRecipient}>
                    <View style={pdfConstants.pdfStyles.row90NoBorder}>
                        <Text style={pdfConstants.pdfStyles.bigColumn100Agreement}>
                            {"Payments are always due upon completion of installation. In the event of non-payment, late fees will be applied as well as criminal charges. In the event of litigation all court fees, attorney expenses, and expenses pertaining to the matter WILL BE PAID BY THE HIRING PARTY. In event we are not able to repossess our equipment for any reason, the client will pay a replacement fee of 10 times the invoiced amount."}
                        </Text>
                    </View>
                </View>

                <View style={pdfConstants.pdfStyles.quoteRecipient}>
                    <View style={pdfConstants.pdfStyles.row90NoBorder}>
                        <Text style={pdfConstants.pdfStyles.bigColumn100Agreement}>
                            {"The homeowner is responsible for providing and maintaining adequate and functional electrical outlets (according to state/local code) adjacent to the proposed locations for lit decorations, tree lights and building lights. GFI receptacles can, will, and should interrupt power to decor or lighting in the presence of water or heavy moisture sometimes caused by rain, fog,  dew, and sprinklers."}
                        </Text>
                    </View>
                </View>

                <View style={pdfConstants.pdfStyles.quoteRecipient}>
                    <View style={pdfConstants.pdfStyles.row60NoBorder}>
                        <Text style={pdfConstants.pdfStyles.bigColumn100Agreement}>
                            {"Wet decor, lighting, outlets and surrounding areas may take several hours after exposure, and in some cases days, to completely dry before receptacles can be reset, and power restored."}
                        </Text>
                    </View>
                </View>

                <View style={pdfConstants.pdfStyles.quoteRecipient}>
                    <View style={pdfConstants.pdfStyles.row60NoBorder}>
                        <Text style={pdfConstants.pdfStyles.bigColumn100Agreement}>
                            {""}
                        </Text>
                    </View>
                </View>

                <View style={pdfConstants.pdfStyles.quoteRecipient}>
                    <View style={pdfConstants.pdfStyles.row60NoBorder}>
                        <Text style={pdfConstants.pdfStyles.bigColumn100Agreement}>
                            {"DESIGN YARD    Christmas Lights LLC is not responsible for outlets that will not reset due to the presence of moisture. Lighting or decor outages must be reported. DESIGN YARD    Christmas Lights LLC is not responsible for unreported outages."}
                        </Text>
                    </View>
                </View>

                <View style={pdfConstants.pdfStyles.quoteRecipient}>
                    <View style={pdfConstants.pdfStyles.row60NoBorder}>
                        <Text style={pdfConstants.pdfStyles.bigColumn100Agreement}>
                            {"Repairs needed due to vandalism/theft, damage caused by animals, and customer added lights are not warrantied and will be billed as additional services starting at (but not limited to) $100."}
                        </Text>
                    </View>
                </View>

                <View style={pdfConstants.pdfStyles.quoteRecipient}>
                    <View style={pdfConstants.pdfStyles.row60NoBorder}>
                        <Text style={pdfConstants.pdfStyles.bigColumn100Agreement}>
                            {"EXCESSIVE PET WASTE:"}
                        </Text>
                    </View>
                </View>

                <View style={pdfConstants.pdfStyles.quoteRecipient}>
                    <View style={pdfConstants.pdfStyles.row90NoBorder}>
                        <Text style={pdfConstants.pdfStyles.bigColumn100Agreement}>
                            {"Nobody wants to stand ankle deep in pet  fecal matter. In cases of excessive pet fecal matter in the work location, we will apply a $100 sanitation fee. This is applied for the cleaning of our materials, tools, trucks, and clothing. This fee will be accessed at the discretion of DESIGN YARD Christmas Lights LLC and it's associates.  "}
                        </Text>
                    </View>
                </View>

                <View style={pdfConstants.pdfStyles.quoteRecipient}>
                    <View style={pdfConstants.pdfStyles.row60NoBorder}>
                        <Text style={pdfConstants.pdfStyles.bigColumn100Agreement}>
                            {"Upon reinstallation, all non-functioning bulbs and/or miniature light sets will be replaced at no additional charge at guaranty time limited."}
                        </Text>
                    </View>
                </View>

                <View style={pdfConstants.pdfStyles.quoteRecipient}>
                    <View style={pdfConstants.pdfStyles.row60NoBorder}>
                        <Text style={pdfConstants.pdfStyles.bigColumn100Agreement}>
                            {"Plant, bushes, and Trees are to be maintained (shaped) before installation. If this is required before installation it will be billed starting at $75."}
                        </Text>
                    </View>
                </View>

                <View style={pdfConstants.pdfStyles.quoteRecipient}>
                    <View style={pdfConstants.pdfStyles.row60NoBorder}>
                        <Text style={pdfConstants.pdfStyles.bigColumn100Agreement}>
                            {"As trees/plants grow, we will add additional lights to any landscape lighting at our discretion, and bill service at the appropriate rates. Any additional items requested at the time of service will also be invoiced accordingly."}
                        </Text>
                    </View>
                </View>

                <View style={pdfConstants.pdfStyles.quoteRecipient}>
                    <View style={pdfConstants.pdfStyles.row60NoBorder}>
                        <Text style={pdfConstants.pdfStyles.bigColumn100Agreement}>
                            {""}
                        </Text>
                    </View>
                </View>

                <View style={pdfConstants.pdfStyles.quoteRecipient}>
                    <View style={pdfConstants.pdfStyles.row60NoBorder}>
                        <Text style={pdfConstants.pdfStyles.bigColumn100Agreement}>
                            {"Deposits: All deposits are refundable until October 1st deposits are nonrefundable after that."}
                        </Text>
                    </View>
                </View>

                <View style={pdfConstants.pdfStyles.quoteRecipient}>
                    <View style={pdfConstants.pdfStyles.row60NoBorder}>
                        <Text style={pdfConstants.pdfStyles.bigColumn100Agreement}>
                            {"The hiring party is responsible for implementing this contract with tenants occupying the facility/property. If there is any problems, questions, or concerns with the understanding of this service agreement/contract. Please, notify DESIGN YARD Christmas lights LLC before work begins."}
                        </Text>
                    </View>
                </View>
                

            </Page>
        </Document>

    );

}

export default AgreementPoliciesPDF;